import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Tooltip } from '@mui/material';

// Components
import { ModelList } from '../../../components/PaginatedList/ModelList';

// Styles
import { HorizontalStack, SmartContainer } from '../../../styles/Containers'
import { StyledP } from '../../../styles/StyledHTML';
import { DefaultContentCard } from '../../components/Content/DefaultContentCard';
import { EmptyList } from '../../components/Empty/EmptyList';
import { hasAccess } from '../../services/CaptureCollabService';
import { restoreView, searchViews } from './redux/views.actions';

import { FullViews } from './redux/views.selectors';
import { EmptyMessage } from '../../components/Empty/EmptyMessage';
import { Role } from '../../../redux/Auth/auth.selectors';
import { useMyPermissions } from '../Permission/redux/permissions.actions';
import { NoPermissions } from '../Permission/NoPermissions';
import { Theme } from '../../../styles/Theme';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { IconFeed, IconGrid, IconView } from '../../Icons';
import { DefaultContentCardList } from '../../components/Content/DefaultContentCardList';


const StyledViewCard = styled(SmartContainer)`
    background-color: ${Theme.colors.baseAlternate};
    color: ${Theme.colors.baseAlternateText};
    width: 100%;
    border-radius: ${Theme.radius};
    min-height: 150px;
`

export const ViewsList = ({ onSelect, prepend = false, noPermissionsRenderer = null, noControls = false }) => {

    // New Modal
    const dispatch = useDispatch();
    const [view, setView] = useState('all');
    const store = FullViews();
    const currentUserRole = Role();
    const { permissions, getFiltersBasedOnMyPermission } = useMyPermissions();
    const [filters, setFilters] = useState(null);

    const [grid, setGrid] = useState(true);

    // Permissions Use Effect
    useEffect(() => {

        if (currentUserRole !== 'owner' && currentUserRole !== 'admin' && permissions) {
            const v = getFiltersBasedOnMyPermission('View');
            if (!v) return; // There are no permission for views found for this user
            setFilters({ id: v });
        }

    }, [permissions])

    // --------------------------
    // Interactions
    // --------------------------

    // On Select
    const handleSelect = (item) => onSelect(item);
    const renderEmpty = () => {

        return (
            <SmartContainer>
                <EmptyMessage title="No Saved Views">
                    <StyledP>Create Views by Searching and Saving the Filters.</StyledP>
                </EmptyMessage>
            </SmartContainer>
        )
    }

    const renderCustomControls = () => {
        if (noControls) return null;

        return (
            <HorizontalStack width="100%" flex align="center" justify="space-between">
                <p></p>
                <SmartContainer>
                    <Tooltip title="List or Grid View" placement="top">
                        <StyledIconButton onClick={() => setGrid(!grid)}>
                            {!grid && (<IconGrid />)}
                            {grid && (<IconFeed />)}
                        </StyledIconButton>
                    </Tooltip>
                </SmartContainer>
            </HorizontalStack>
        )
    }

    const renderMediaCard = (item, onClickItem) => {
        if (!grid) return (<DefaultContentCardList content={item} onClick={onClickItem} model="View" noImage={true} />)
        return (<DefaultContentCard content={item} onClick={onClickItem} model="View" noImage={true} />)
    }

    // No Permissions At All
    if (currentUserRole !== 'owner' && currentUserRole !== 'admin' && !filters) {
        if (noPermissionsRenderer) return noPermissionsRenderer();
        return (<NoPermissions checked="checked" />)
    }

    const variant = (grid) ? 'cards' : 'list';

    // Render Page
    return (
        <ModelList
            model="view"
            action={searchViews}
            restore={restoreView}
            selector={FullViews}
            onSelect={handleSelect}
            variant={variant}
            defaultLimit={999}
            emptyRenderer={renderEmpty}
            mobileColumns={2}
            filters={filters}
            hideSearch={true}
            customRenderer={renderMediaCard}
            paginationControls={renderCustomControls}
            noControls={noControls}
        />
    )
}